import { ownerComponent } from './owner.component';
import { stateResolver } from '../../app.state';

export const ownerStateName = 'app.owner';

export const ownerState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    url: '/owner',
    name: ownerStateName,
    component: ownerComponent.name,
    resolve: { stateResolver: stateResolver(ownerStateName) },
  });
};



// WEBPACK FOOTER //
// ./src/app/components/owner/owner.state.js